import { USER_API_ENDPOINTS } from "@/features/auth/config/userApiPath";
import { fetcher } from "@/shared/lib/fetcher.client";
import type { UserResponse, UpdateUserData, UpdateUserApiPayload } from "@/shared/types/";

export const updateUser = async (userData: UpdateUserApiPayload): Promise<UserResponse> => {
  try {
    const response = await fetcher.put<UserResponse>(USER_API_ENDPOINTS.ME, userData);
    return response.data;
  }
  catch (error: unknown) {
    throw error instanceof Error ? error : new Error("Erreur lors de la mise à jour de votre profil");
  }
};

export const updateUserLegacy = async (userData: UpdateUserData): Promise<UserResponse> => {
  const cleanedUserData = { ...userData };
  if (cleanedUserData.dialing_code) {
    cleanedUserData.dialing_code = cleanedUserData.dialing_code.replace(/^\+/, "");
  }
  return updateUser({ employee: cleanedUserData });
};
